import { render } from "./PackagePhoto.vue?vue&type=template&id=6360f8d8&scoped=true"
import script from "./PackagePhoto.vue?vue&type=script&lang=js"
export * from "./PackagePhoto.vue?vue&type=script&lang=js"

import "./PackagePhoto.vue?vue&type=style&index=0&id=6360f8d8&scoped=true&lang=css"
import "./PackagePhoto.vue?vue&type=style&index=1&id=6360f8d8&lang=css"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6360f8d8"]])

export default __exports__